import { useEffect, useState } from "react";

export function useScrollSpy(sectionIds: string[], offset = 100) {
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    const handler = () => {
      // First check if we're near the top - if so, don't highlight anything
      if (window.scrollY < offset) {
        setActiveId(null);
        return;
      }

      // Otherwise check which section is in view
      let found = null;
      for (let i = 0; i < sectionIds.length; i++) {
        const el = document.getElementById(sectionIds[i]);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top < offset + 10 && rect.bottom > offset) {
            found = sectionIds[i];
            break;
          }
        }
      }
      setActiveId(found || null);
    };

    window.addEventListener("scroll", handler, { passive: true });
    handler(); // initial

    return () => window.removeEventListener("scroll", handler);
  }, [sectionIds, offset]);

  return activeId;
}
